const clinicalTrialsTheme = {
  dot: "bg-emerald-400",
  accentText: "text-emerald-200",
  subtleText: "text-emerald-300",
  tabActive: "border-emerald-400/40 bg-emerald-500/10 text-emerald-100",
  selectedRow: "border-l-2 border-emerald-400 bg-emerald-500/[0.08]",
  accentBadge: "border border-emerald-400/30 bg-emerald-500/10 text-emerald-100",
  idBadge: "border border-emerald-400/25 bg-emerald-500/5 text-emerald-100",
  detailBorder: "border-emerald-400/25",
  detailGlow: "from-emerald-400/25",
  checkbox:
    "border-emerald-300/35 text-emerald-200 hover:border-emerald-200/55 hover:bg-emerald-950/70 focus-visible:ring-emerald-300/25",
  checkboxChecked:
    "border-emerald-100/70 from-emerald-300 to-teal-400 shadow-[0_0_0_1px_rgba(209,250,229,0.16),0_10px_22px_rgba(16,185,129,0.24)]",
};

export default clinicalTrialsTheme;
